import React from 'react';
import styles from './LandingPage.module.css';

function initialsFromName(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

export default function Testimonials({ testimonials = [], language = 'en' }) {
  if (!testimonials.length) return null;

  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Testimonios' : 'Social Proof';
  const title = lang === 'es' ? 'Lo que dicen los participantes' : 'What Attendees Say';

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.testimonialsGrid}>
          {testimonials.map((t, idx) => {
            const content = t.content ?? t.testimonial ?? '';
            const name = t.name ?? t.author_name ?? 'Guest';
            const loc = t.location ?? t.author_location ?? '';
            return (
              <div key={t.id ?? idx} className={styles.testimonialCard}>
                <div className={styles.stars}>★★★★★</div>
                <p className={styles.testimonialQuote}>&ldquo;{content}&rdquo;</p>
                <div className={styles.testimonialAuthor}>
                  <div className={styles.authorAvatar}>{initialsFromName(name)}</div>
                  <div>
                    <div className={styles.authorName}>{name}</div>
                    {loc ? <div className={styles.authorLocation}>{loc}</div> : null}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
